module.exports = __webpack_public_path__ + "static/media/portfolio1 (26).b28a1aef.jpeg";